import { UUID } from "api/types";
import { wmsFileFactory } from "api/wms/calls";
import { useDownloadFeedbackToastr } from "components/utils/downloadFeedback/DownloadFeedbackController";
import { fileDownloader } from "fileDownloader";

export const useDownloadUnloadingLineItemPdf = () => {
  const downloadFeedbackToastr = useDownloadFeedbackToastr();

  async function handleDownloadUnloadingLineItemPdf(
    lineItemId: UUID,
    unloading: UUID,
    signature: string,
  ) {
    if (!lineItemId || !unloading) throw new Error("An error occurred");
    const tstr = downloadFeedbackToastr.open({ type: "pdf" });
    const { url, name } = wmsFileFactory.unloadingLineItemPdf({
      unloading,
      signature,
      id: lineItemId,
    });
    const response = await fileDownloader({
      onProgress: tstr.updateProgress,
      url,
      name,
      type: "pdf",
    });
    if (response.status === "success") {
      tstr.lazyClose();
    }
  }

  return handleDownloadUnloadingLineItemPdf;
};
